import { jsx as _jsx } from "react/jsx-runtime";
export function SettingsPage() {
    return _jsx("div", { children: "SettingsPage" });
}
